/**
 * @generated SignedSource<<8f7c7447391737a094224f64342c0c92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DraftInvoiceViewDownloadPdfMutation$variables = {
  id: string;
};
export type DraftInvoiceViewDownloadPdfMutation$data = {
  readonly downloadInvoicePdf: {
    readonly filename: string;
    readonly uri: string;
  } | null | undefined;
};
export type DraftInvoiceViewDownloadPdfMutation = {
  response: DraftInvoiceViewDownloadPdfMutation$data;
  variables: DraftInvoiceViewDownloadPdfMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TemporaryDownload",
    "kind": "LinkedField",
    "name": "downloadInvoicePdf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DraftInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ec8915f622466f2ac13f81ea11f3e39",
    "id": null,
    "metadata": {},
    "name": "DraftInvoiceViewDownloadPdfMutation",
    "operationKind": "mutation",
    "text": "mutation DraftInvoiceViewDownloadPdfMutation(\n  $id: ID!\n) {\n  downloadInvoicePdf(input: {id: $id}) {\n    uri\n    filename\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3be0e0da50cfce37637678478ec2274";

export default node;
